const countryCodes = [
  {
    name: "Afghanistan",
    label: "+93",
    value: "+93",
    code: "AF",
  },
  {
    name: "Aland Islands",
    label: "+358",
    value: "+358",
    code: "AX",
  },
  {
    name: "Albania",
    label: "+355",
    value: "+355",
    code: "AL",
  },
  {
    name: "Algeria",
    label: "+213",
    value: "+213",
    code: "DZ",
  },
  {
    name: "AmericanSamoa",
    label: "+1684",
    value: "+1684",
    code: "AS",
  },
  {
    name: "Andorra",
    label: "+376",
    value: "+376",
    code: "AD",
  },
  {
    name: "Angola",
    label: "+244",
    value: "+244",
    code: "AO",
  },
  {
    name: "Anguilla",
    label: "+1264",
    value: "+1264",

    code: "AI",
  },
  {
    name: "Antarctica",
    label: "+672",
    value: "+672",

    code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    label: "+1268",
    value: "+1268",

    code: "AG",
  },
  {
    name: "Argentina",
    label: "+54",
    value: "+54",

    code: "AR",
  },
  {
    name: "Armenia",
    label: "+374",
    value: "+374",

    code: "AM",
  },
  {
    name: "Aruba",
    label: "+297",
    value: "+297",

    code: "AW",
  },
  {
    name: "Australia",
    label: "+61",
    value: "+61",

    code: "AU",
  },
  {
    name: "Austria",
    label: "+43",
    value: "+43",

    code: "AT",
  },
  {
    name: "Azerbaijan",
    label: "+994",
    value: "+994",

    code: "AZ",
  },
  {
    name: "Bahamas",
    label: "+1242",
    value: "+1242",

    code: "BS",
  },
  {
    name: "Bahrain",
    label: "+973",
    value: "+973",

    code: "BH",
  },
  {
    name: "Bangladesh",
    label: "+880",
    value: "+880",

    code: "BD",
  },
  {
    name: "Barbados",
    label: "+1246",
    value: "+1246",

    code: "BB",
  },
  {
    name: "Belarus",
    label: "+375",
    value: "+375",

    code: "BY",
  },
  {
    name: "Belgium",
    label: "+32",
    value: "+32",

    code: "BE",
  },
  {
    name: "Belize",
    label: "+501",
    value: "+501",

    code: "BZ",
  },
  {
    name: "Benin",
    label: "+229",
    value: "+229",

    code: "BJ",
  },
  {
    name: "Bermuda",
    label: "+1441",
    value: "+1441",

    code: "BM",
  },
  {
    name: "Bhutan",
    label: "+975",
    value: "+975",

    code: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",
    label: "+591",
    value: "+591",

    code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    label: "+387",
    value: "+387",

    code: "BA",
  },
  {
    name: "Botswana",
    label: "+267",
    value: "+267",

    code: "BW",
  },
  {
    name: "Brazil",
    label: "+55",
    value: "+55",

    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    label: "+246",
    value: "+246",

    code: "IO",
  },
  {
    name: "Brunei Darussalam",
    label: "+673",
    value: "+673",

    code: "BN",
  },
  {
    name: "Bulgaria",
    label: "+359",
    value: "+359",

    code: "BG",
  },
  {
    name: "Burkina Faso",
    label: "+226",
    value: "+226",

    code: "BF",
  },
  {
    name: "Burundi",
    label: "+257",
    value: "+257",

    code: "BI",
  },
  {
    name: "Cambodia",
    label: "+855",
    value: "+855",

    code: "KH",
  },
  {
    name: "Cameroon",
    label: "+237",
    value: "+237",

    code: "CM",
  },
  {
    name: "Canada",
    label: "+1",
    value: "+1",

    code: "CA",
  },
  {
    name: "Cape Verde",
    label: "+238",
    value: "+238",

    code: "CV",
  },
  {
    name: "Cayman Islands",
    label: "+ 345",
    value: "+ 345",

    code: "KY",
  },
  {
    name: "Central African Republic",
    label: "+236",
    value: "+236",

    code: "CF",
  },
  {
    name: "Chad",
    label: "+235",
    value: "+235",

    code: "TD",
  },
  {
    name: "Chile",
    label: "+56",
    value: "+56",

    code: "CL",
  },
  {
    name: "China",
    label: "+86",
    value: "+86",

    code: "CN",
  },
  {
    name: "Christmas Island",
    label: "+61",
    value: "+61",

    code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    label: "+61",
    value: "+61",

    code: "CC",
  },
  {
    name: "Colombia",
    label: "+57",
    value: "+57",

    code: "CO",
  },
  {
    name: "Comoros",
    label: "+269",
    value: "+269",

    code: "KM",
  },
  {
    name: "Congo",
    label: "+242",
    value: "+242",

    code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    label: "+243",
    value: "+243",

    code: "CD",
  },
  {
    name: "Cook Islands",
    label: "+682",
    value: "+682",

    code: "CK",
  },
  {
    name: "Costa Rica",
    label: "+506",
    value: "+506",

    code: "CR",
  },
  {
    name: "Cote d'Ivoire",
    label: "+225",
    value: "+225",

    code: "CI",
  },
  {
    name: "Croatia",
    label: "+385",
    value: "+385",
    code: "HR",
  },
  {
    name: "Cuba",
    label: "+53",
    value: "+53",
    code: "CU",
  },
  {
    name: "Cyprus",
    label: "+357",
    value: "+357",
    code: "CY",
  },
  {
    name: "Czech Republic",
    value: "+420",
    label: "+420",
    code: "CZ",
  },
  {
    name: "Denmark",
    label: "+45",
    value: "+45",
    code: "DK",
  },
  {
    name: "Djibouti",
    label: "+253",
    value: "+253",
    code: "DJ",
  },
  {
    name: "Dominica",
    label: "+1767",
    value: "+1767",
    code: "DM",
  },
  {
    name: "Dominican Republic",
    label: "+1849",
    value: "+1849",
    code: "DO",
  },
  {
    name: "Ecuador",
    label: "+593",
    value: "+593",
    code: "EC",
  },
  {
    name: "Egypt",
    label: "+20",
    value: "+20",
    code: "EG",
  },
  {
    name: "El Salvador",
    label: "+503",
    value: "+503",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    label: "+240",
    value: "+240",
    code: "GQ",
  },
  {
    name: "Eritrea",
    label: "+291",
    value: "+291",
    code: "ER",
  },
  {
    name: "Estonia",
    label: "+372",
    value: "+372",
    code: "EE",
  },
  {
    name: "Ethiopia",
    label: "+251",
    value: "+251",
    code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    label: "+500",
    value: "+500",
    code: "FK",
  },
  {
    name: "Faroe Islands",
    label: "+298",
    value: "+298",
    code: "FO",
  },
  {
    name: "Fiji",
    label: "+679",
    value: "+679",
    code: "FJ",
  },
  {
    name: "Finland",
    label: "+358",
    value: "+358",
    code: "FI",
  },
  {
    name: "France",
    label: "+33",
    value: "+33",
    code: "FR",
  },
  {
    name: "French Guiana",
    label: "+594",
    value: "+594",
    code: "GF",
  },
  {
    name: "French Polynesia",
    label: "+689",
    value: "+689",
    code: "PF",
  },
  {
    name: "Gabon",
    label: "+241",
    value: "+241",
    code: "GA",
  },
  {
    name: "Gambia",
    label: "+220",
    value: "+220",
    code: "GM",
  },
  {
    name: "Georgia",
    label: "+995",
    value: "+995",
    code: "GE",
  },
  {
    name: "Germany",
    label: "+49",
    value: "+49",
    code: "DE",
  },
  {
    name: "Ghana",
    label: "+233",
    value: "+233",
    code: "GH",
  },
  {
    name: "Gibraltar",
    label: "+350",
    value: "+350",
    code: "GI",
  },
  {
    name: "Greece",
    label: "+30",
    value: "+30",
    code: "GR",
  },
  {
    name: "Greenland",
    label: "+299",
    value: "+299",
    code: "GL",
  },
  {
    name: "Grenada",
    label: "+1473",
    value: "+1473",
    code: "GD",
  },
  {
    name: "Guadeloupe",
    label: "+590",
    value: "+590",
    code: "GP",
  },
  {
    name: "Guam",
    label: "+1671",
    value: "+1671",
    code: "GU",
  },
  {
    name: "Guatemala",
    label: "+502",
    value: "+502",
    code: "GT",
  },
  {
    name: "Guernsey",
    label: "+44",
    value: "+44",
    code: "GG",
  },
  {
    name: "Guinea",
    label: "+224",
    value: "+224",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    label: "+245",
    value: "+245",
    code: "GW",
  },
  {
    name: "Guyana",
    label: "+595",
    value: "+595",
    code: "GY",
  },
  {
    name: "Haiti",
    label: "+509",
    value: "+509",
    code: "HT",
  },
  {
    name: "Holy See (Vatican City State)",
    label: "+379",
    value: "+379",
    code: "VA",
  },
  {
    name: "Honduras",
    label: "+504",
    value: "+504",
    code: "HN",
  },
  {
    name: "Hong Kong",
    label: "+852",
    value: "+852",
    code: "HK",
  },
  {
    name: "Hungary",
    label: "+36",
    value: "+36",
    code: "HU",
  },
  {
    name: "Iceland",
    label: "+354",
    value: "+354",
    code: "IS",
  },
  {
    name: "India",
    label: "+91",
    value: "+91",
    code: "IN",
  },
  {
    name: "Indonesia",
    label: "+62",
    value: "+62",
    code: "ID",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    label: "+98",
    value: "+98",
    code: "IR",
  },
  {
    name: "Iraq",
    label: "+964",
    value: "+964",
    code: "IQ",
  },
  {
    name: "Ireland",
    label: "+353",
    value: "+353",
    code: "IE",
  },
  {
    name: "Isle of Man",
    label: "+44",
    value: "+44",
    code: "IM",
  },
  {
    name: "Israel",
    label: "+972",
    value: "+972",
    code: "IL",
  },
  {
    name: "Italy",
    label: "+39",
    value: "+39",
    code: "IT",
  },
  {
    name: "Jamaica",
    label: "+1876",
    value: "+1876",
    code: "JM",
  },
  {
    name: "Japan",
    label: "+81",
    value: "+81",
    code: "JP",
  },
  {
    name: "Jersey",
    label: "+44",
    value: "+44",
    code: "JE",
  },
  {
    name: "Jordan",
    label: "+962",
    value: "+962",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    label: "+77",
    value: "+77",
    code: "KZ",
  },
  {
    name: "Kenya",
    label: "+254",
    value: "+254",
    code: "KE",
  },
  {
    name: "Kiribati",
    label: "+686",
    value: "+686",
    code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    label: "+850",
    value: "+850",
    code: "KP",
  },
  {
    name: "Korea, Republic of South Korea",
    label: "+82",
    value: "+82",
    code: "KR",
  },
  {
    name: "Kuwait",
    label: "+965",
    value: "+965",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    label: "+996",
    value: "+996",
    code: "KG",
  },
  {
    name: "Laos",
    label: "+856",
    value: "+856",
    code: "LA",
  },
  {
    name: "Latvia",
    label: "+371",
    value: "+371",
    code: "LV",
  },
  {
    name: "Lebanon",
    label: "+961",
    value: "+961",
    code: "LB",
  },
  {
    name: "Lesotho",
    label: "+266",
    value: "+266",
    code: "LS",
  },
  {
    name: "Liberia",
    label: "+231",
    value: "+231",
    code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    label: "+218",
    value: "+218",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    label: "+423",
    value: "+423",
    code: "LI",
  },
  {
    name: "Lithuania",
    label: "+370",
    value: "+370",
    code: "LT",
  },
  {
    name: "Luxembourg",
    label: "+352",
    value: "+352",
    code: "LU",
  },
  {
    name: "Macao",
    label: "+853",
    value: "+853",
    code: "MO",
  },
  {
    name: "Macedonia",
    label: "+389",
    value: "+389",
    code: "MK",
  },
  {
    name: "Madagascar",
    label: "+261",
    value: "+261",
    code: "MG",
  },
  {
    name: "Malawi",
    label: "+265",
    value: "+265",
    code: "MW",
  },
  {
    name: "Malaysia",
    label: "+60",
    value: "+60",
    code: "MY",
  },
  {
    name: "Maldives",
    label: "+960",
    value: "+960",
    code: "MV",
  },
  {
    name: "Mali",
    label: "+223",
    value: "+223",
    code: "ML",
  },
  {
    name: "Malta",
    label: "+356",
    value: "+356",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    label: "+692",
    value: "+692",
    code: "MH",
  },
  {
    name: "Martinique",
    label: "+596",
    value: "+596",
    code: "MQ",
  },
  {
    name: "Mauritania",
    label: "+222",
    value: "+222",
    code: "MR",
  },
  {
    name: "Mauritius",
    label: "+230",
    value: "+230",
    code: "MU",
  },
  {
    name: "Mayotte",
    label: "+262",
    value: "+262",
    code: "YT",
  },
  {
    name: "Mexico",
    label: "+52",
    value: "+52",
    code: "MX",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    label: "+691",
    value: "+691",
    code: "FM",
  },
  {
    name: "Moldova",
    label: "+373",
    value: "+373",
    code: "MD",
  },
  {
    name: "Monaco",
    label: "+377",
    value: "+377",
    code: "MC",
  },
  {
    name: "Mongolia",
    label: "+976",
    value: "+976",
    code: "MN",
  },
  {
    name: "Montenegro",
    label: "+382",
    value: "+382",
    code: "ME",
  },
  {
    name: "Montserrat",
    label: "+1664",
    value: "+1664",
    code: "MS",
  },
  {
    name: "Morocco",
    label: "+212",
    value: "+212",
    code: "MA",
  },
  {
    name: "Mozambique",
    label: "+258",
    value: "+258",
    code: "MZ",
  },
  {
    name: "Myanmar",
    label: "+95",
    value: "+95",
    code: "MM",
  },
  {
    name: "Namibia",
    label: "+264",
    value: "+264",
    code: "NA",
  },
  {
    name: "Nauru",
    label: "+674",
    value: "+674",
    code: "NR",
  },
  {
    name: "Nepal",
    label: "+977",
    value: "+977",
    code: "NP",
  },
  {
    name: "Netherlands",
    label: "+31",
    value: "+31",
    code: "NL",
  },
  {
    name: "Netherlands Antilles",
    label: "+599",
    value: "+599",
    code: "AN",
  },
  {
    name: "New Caledonia",
    label: "+687",
    value: "+687",
    code: "NC",
  },
  {
    name: "New Zealand",
    label: "+64",
    value: "+64",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    label: "+505",
    value: "+505",
    code: "NI",
  },
  {
    name: "Niger",
    label: "+227",
    value: "+227",
    code: "NE",
  },
  {
    name: "Nigeria",
    label: "+234",
    value: "+234",
    code: "NG",
  },
  {
    name: "Niue",
    label: "+683",
    value: "+683",
    code: "NU",
  },
  {
    name: "Norfolk Island",
    label: "+672",
    value: "+672",
    code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    label: "+1670",
    value: "+1670",
    code: "MP",
  },
  {
    name: "Norway",
    label: "+47",
    value: "+47",
    code: "NO",
  },
  {
    name: "Oman",
    label: "+968",
    value: "+968",
    code: "OM",
  },
  {
    name: "Pakistan",
    label: "+92",
    value: "+92",
    code: "PK",
  },
  {
    name: "Palau",
    label: "+680",
    value: "+680",
    code: "PW",
  },
  {
    name: "Palestinian Territory, Occupied",
    label: "+970",
    value: "+970",
    code: "PS",
  },
  {
    name: "Panama",
    label: "+507",
    value: "+507",
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    label: "+675",
    value: "+675",
    code: "PG",
  },
  {
    name: "Paraguay",
    label: "+595",
    value: "+595",
    code: "PY",
  },
  {
    name: "Peru",
    label: "+51",
    value: "+51",
    code: "PE",
  },
  {
    name: "Philippines",
    label: "+63",
    value: "+63",
    code: "PH",
  },
  {
    name: "Pitcairn",
    label: "+872",
    value: "+872",
    code: "PN",
  },
  {
    name: "Poland",
    label: "+48",
    value: "+48",
    code: "PL",
  },
  {
    name: "Portugal",
    label: "+351",
    value: "+351",
    code: "PT",
  },
  {
    name: "Puerto Rico",
    label: "+1939",
    value: "+1939",
    code: "PR",
  },
  {
    name: "Qatar",
    label: "+974",
    value: "+974",
    code: "QA",
  },
  {
    name: "Romania",
    label: "+40",
    value: "+40",
    code: "RO",
  },
  {
    name: "Russia",
    label: "+7",
    value: "+7",
    code: "RU",
  },
  {
    name: "Rwanda",
    label: "+250",
    value: "+250",
    code: "RW",
  },
  {
    name: "Reunion",
    label: "+262",
    value: "+262",
    code: "RE",
  },
  {
    name: "Saint Barthelemy",
    label: "+590",
    value: "+590",
    code: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    label: "+290",
    value: "+290",
    code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    label: "+1869",
    value: "+1869",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    label: "+1758",
    value: "+1758",
    code: "LC",
  },
  {
    name: "Saint Martin",
    label: "+590",
    value: "+590",
    code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    label: "+508",
    value: "+508",
    code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    label: "+1784",
    value: "+1784",
    code: "VC",
  },
  {
    name: "Samoa",
    label: "+685",
    value: "+685",
    code: "WS",
  },
  {
    name: "San Marino",
    label: "+378",
    value: "+378",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    label: "+239",
    value: "+239",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    label: "+966",
    value: "+966",
    code: "SA",
  },
  {
    name: "Senegal",
    label: "+221",
    value: "+221",
    code: "SN",
  },
  {
    name: "Serbia",
    label: "+381",
    value: "+381",
    code: "RS",
  },
  {
    name: "Seychelles",
    label: "+248",
    value: "+248",
    code: "SC",
  },
  {
    name: "Sierra Leone",
    label: "+232",
    value: "+232",
    code: "SL",
  },
  {
    name: "Singapore",
    label: "+65",
    value: "+65",
    code: "SG",
  },
  {
    name: "Slovakia",
    label: "+421",
    value: "+421",
    code: "SK",
  },
  {
    name: "Slovenia",
    label: "+386",
    value: "+386",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    label: "+677",
    value: "+677",
    code: "SB",
  },
  {
    name: "Somalia",
    label: "+252",
    value: "+252",
    code: "SO",
  },
  {
    name: "South Africa",
    label: "+27",
    value: "+27",
    code: "ZA",
  },
  {
    name: "South Sudan",
    label: "+211",
    value: "+211",
    code: "SS",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    label: "+500",
    value: "+500",
    code: "GS",
  },
  {
    name: "Spain",
    label: "+34",
    value: "+34",
    code: "ES",
  },
  {
    name: "Sri Lanka",
    label: "+94",
    value: "+94",
    code: "LK",
  },
  {
    name: "Sudan",
    label: "+249",
    value: "+249",
    code: "SD",
  },
  {
    name: "Suriname",
    label: "+597",
    value: "+597",
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    label: "+47",
    value: "+47",
    code: "SJ",
  },
  {
    name: "Swaziland",
    label: "+268",
    value: "+268",
    code: "SZ",
  },
  {
    name: "Sweden",
    label: "+46",
    value: "+46",
    code: "SE",
  },
  {
    name: "Switzerland",
    label: "+41",
    value: "+41",
    code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    label: "+963",
    value: "+963",
    code: "SY",
  },
  {
    name: "Taiwan",
    label: "+886",
    value: "+886",
    code: "TW",
  },
  {
    name: "Tajikistan",
    label: "+992",
    value: "+992",
    code: "TJ",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    label: "+255",
    value: "+255",
    code: "TZ",
  },
  {
    name: "Thailand",
    label: "+66",
    value: "+66",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    label: "+670",
    value: "+670",
    code: "TL",
  },
  {
    name: "Togo",
    label: "+228",
    value: "+228",
    code: "TG",
  },
  {
    name: "Tokelau",
    label: "+690",
    value: "+690",
    code: "TK",
  },
  {
    name: "Tonga",
    label: "+676",
    value: "+676",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    label: "+1868",
    value: "+1868",
    code: "TT",
  },
  {
    name: "Tunisia",
    label: "+216",
    value: "+216",
    code: "TN",
  },
  {
    name: "Turkey",
    label: "+90",
    value: "+90",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    label: "+993",
    value: "+993",
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    label: "+1649",
    value: "+1649",
    code: "TC",
  },
  {
    name: "Tuvalu",
    label: "+688",
    value: "+688",
    code: "TV",
  },
  {
    name: "Uganda",
    label: "+256",
    value: "+256",
    code: "UG",
  },
  {
    name: "Ukraine",
    label: "+380",
    value: "+380",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    label: "+971",
    value: "+971",
    code: "AE",
  },
  {
    name: "United Kingdom",
    label: "+44",
    value: "+44",
    code: "GB",
  },
  {
    name: "United States",
    label: "+1",
    value: "+1",
    code: "US",
  },
  {
    name: "Uruguay",
    label: "+598",
    value: "+598",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    label: "+998",
    value: "+998",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    label: "+678",
    value: "+678",
    code: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    label: "+58",
    value: "+58",
    code: "VE",
  },
  {
    name: "Vietnam",
    label: "+84",
    value: "+84",
    code: "VN",
  },
  {
    name: "Virgin Islands, British",
    label: "+1284",
    value: "+1284",
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    label: "+1340",
    value: "+1340",
    code: "VI",
  },
  {
    name: "Wallis and Futuna",
    label: "+681",
    value: "+681",
    code: "WF",
  },
  {
    name: "Yemen",
    label: "+967",
    value: "+967",
    code: "YE",
  },
  {
    name: "Zambia",
    label: "+260",
    value: "+260",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    label: "+263",
    value: "+263",
    code: "ZW",
  },
];

export default countryCodes;
